var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promo main-block"},[_c('div',{staticClass:"promo__content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('launchpad.banner.title')))]),_c('p',{staticClass:"subline"},[_vm._v(_vm._s(_vm.$t('launchpad.banner.subline')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('launchpad.banner.text'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }